module.exports = "<h2 md-dialog-title class=\"mb_0\">\n Remove Attendee\n <button class=\"popup_close float-right\" md-button [md-dialog-close]=\"true\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button>\n</h2>\n<md-dialog-content>\n    <b class=\"red_text\">To remove attendee you must contact {{CONTACT_NAME}} directly.</b>\n    <b>Phone : 800-229-9541</b>\n    <b>Email : {{CONTACT_EMAIL}}</b>\n</md-dialog-content>\n\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/delete-attendee-warning/delete-attendee-warning.component.html
// module id = ../../../../../src/app/delete-attendee-warning/delete-attendee-warning.component.html
// module chunks = 39